/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./digitalTwinList.vue?vue&type=template&id=099a8b27&scoped=true"
import script from "./digitalTwinList.vue?vue&type=script&lang=js"
export * from "./digitalTwinList.vue?vue&type=script&lang=js"
import style0 from "./digitalTwinList.vue?vue&type=style&index=0&id=099a8b27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099a8b27",
  null
  
)

export default component.exports